// @ts-nocheck
import React, { useState, useEffect } from 'react';

const ignoreDonationChange = () => {};

const Donation = ({ id, label, element_value, fixed = false, onDonationChange = ignoreDonationChange, simple = false, compact = false }) => {
	const [suggestion, setSuggestion] = useState(0);
	const [amount, setAmount] = useState(0);

	useEffect(() => {
		const parsed = parseFloat(element_value?.toString().replace(',', '.'));
		const initialAmount = !isNaN(parsed) && parsed > 0 ? parsed : 0;
		setSuggestion(initialAmount);
		setAmount(initialAmount);
	}, [element_value]);

	const updateAmount = (nextAmount) => {
		const safeAmount = Math.max(0, Number(nextAmount) || 0);
		setAmount(safeAmount);
		onDonationChange(id, safeAmount);
	};

	const handleChange = (e) => {
		let val = e.target.value.replace(',', '.');
		const regex = /^\d*\.?\d{0,2}$/;
		if (regex.test(val) || val === '') {
			updateAmount(val === '' ? 0 : parseFloat(val));
		}
	};

	if (simple) {
		return (
			<div className={`${compact ? 'm-0 p-3' : 'm-2 mr-5 p-4'} w-full overflow-hidden rounded border bg-white shadow`}>
				<div className={`flex justify-between ${compact ? 'flex-col items-stretch gap-3' : 'flex-col items-center md:flex-row md:items-start'}`}>
					<div className={`${compact ? 'mb-0 px-3' : 'mb-5 p-2 lg:mr-5'} flex min-h-16 w-full min-w-0 items-center justify-between gap-2 rounded-md border bg-white shadow-sm`}>
						<span className="text-gray-500 font-medium text-sm uppercase flex-grow">{label}</span>
						{suggestion > 0 && (
							<span className="text-gray-400 text-sm ml-2">
							(Sugestão: {suggestion.toFixed(2).replace('.', ',')}€)
						</span>
						)}
					</div>
					<div className={`${compact ? 'mb-0 w-full px-3' : 'mb-5 w-full p-2 md:w-fit'} flex min-h-16 items-center justify-between gap-2 rounded-md border bg-white shadow-sm`}>
						<span className="text-gray-500 mr-2 font-medium text-sm uppercase tracking-wider">Valor</span>
						<input
							type="text"
							className='text-xl border-transparent font-bold focus:border-transparent focus:ring-transparent w-20 md:w-24 text-center'
							value={amount.toFixed(2).replace('.', ',')}
							onChange={handleChange}
							onWheel={() => document.activeElement.blur()}
						/>
					</div>
				</div>
			</div>
		);
	}


	return (
		<div className="mb-5 flex w-full flex-col gap-3 md:flex-row md:items-center md:justify-between">
			{/* Label and suggestion */}
			<div className="flex min-h-16 w-full items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-sm lg:mr-4">
				<span className="font-semibold text-slate-700">{label || 'Donativo'}</span>
				{suggestion > 0 && (
					<span className="text-gray-400 text-sm ml-2">
						(Sugestão: {suggestion.toFixed(2).replace('.', ',')}€)
					</span>
				)}
			</div>

			{/* Donation input */}
			<div className="flex h-16 w-full items-center justify-between rounded-2xl border border-slate-200 bg-white p-2 shadow-sm md:w-fit">
				<span className="text-gray-500 mr-2 font-medium text-sm uppercase tracking-wider">Valor</span>
				{!fixed && <button type="button" aria-label="Diminuir donativo" onClick={() => updateAmount(parseFloat((amount - 0.5).toFixed(2)))}
						className="flex h-10 w-10 shrink-0 items-center justify-center rounded-l-xl bg-green-cl text-white transition hover:bg-emerald-800">-</button>
                }
				<input
					type="text"
					className='text-xl border-transparent font-bold focus:border-transparent focus:ring-transparent w-20 md:w-24 text-center'
					value={amount.toFixed(2).replace('.', ',')}
					aria-label={`Valor do donativo ${label || ''}`}
					inputMode="decimal"
					onChange={handleChange}
					readOnly={fixed}
					onWheel={() => document.activeElement.blur()}
				/>
				{!fixed && <button type="button" aria-label="Aumentar donativo" onClick={() => updateAmount(parseFloat((amount + 0.5).toFixed(2)))}
						className="flex h-10 w-10 shrink-0 items-center justify-center rounded-r-xl bg-green-cl text-white transition hover:bg-emerald-800">+</button>
                }
			</div>
		</div>
	);
};

export default Donation;
